import React from 'react';
import { Icons } from '../Icons/Icons';

export interface DotBtnTrigger {
    onClick: any
}

export const DotBtnTrigger = ({onClick, ...props}: DotBtnTrigger) => {
    return (
        <div className={'btn-dots__icon'} onClick={() => onClick()}>
            <Icons />
            <svg viewBox="0 0 4 20" className="icon icon--dots">
                <use xlinkHref={'#dots'}></use>
            </svg>
        </div>
    )
}
